import api, { getResponseError } from '../../services/api'
import { IErrorResponse } from '../types/ErrorResponse'
import {
  IAnticipationReconciliationFilter,
  TAnticipationReconciliationDetail,
  TAnticipationReconciliationPagination,
} from '../types/AnticipationReconciliation'

const BASE = '/Report/anticipation-reconciliations'

const getAll = async ({
  page,
  rows,
  search,
  startDate,
  endDate,
  products,
  affiliateds,
}: IAnticipationReconciliationFilter): Promise<
  TAnticipationReconciliationPagination | IErrorResponse
> => {
  try {
    let path = `${BASE}?PageNumber=${page}&RowsPerPage=${rows}`
    if (search) path += `&Search=${encodeURIComponent(search)}`
    if (startDate) {
      path += `&StartPeriod=${startDate.toISOString()}&EndPeriod=${(endDate ?? new Date()).toISOString()}`
    }
    if (products?.length) path += `&Products=${products.join(';')}`
    if (affiliateds?.length) path += `&Affiliateds=${affiliateds.join(';')}`

    const { data } = await api.get<TAnticipationReconciliationPagination>(path)
    return data ?? { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return { code: 2, error: getResponseError(error) }
  }
}

const get = async (
  orderChargeId: string
): Promise<TAnticipationReconciliationDetail | IErrorResponse> => {
  try {
    const { data } = await api.get<TAnticipationReconciliationDetail>(
      `${BASE}/${orderChargeId}`
    )
    return data ?? { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return {
        code: 404,
        error: 'Esta cobrança não teve ajuste de antecipação.',
      }
    }
    return { code: 2, error: getResponseError(error) }
  }
}

export const AnticipationReconciliationController = { getAll, get }
